import React, { useState, useEffect, useMemo } from 'react';
import { api } from '@/lib/api';
import { MonthlyConsumptionSlide } from '@/components/MonthlyConsumptionSlide';
import { MultiSelectFilter } from '@/components/MultiSelectFilter';
import { Filter } from 'lucide-react';

export default function MonthlyConsumption() {
  const [projects, setProjects] = useState([]);
  const [adhocInvoices, setAdhocInvoices] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);

  useEffect(() => {
    Promise.all([api.getProjects(), api.getAdhocInvoices()])
      .then(([projs, adhocs]) => { setProjects(projs); setAdhocInvoices(adhocs); })
      .catch(() => { setProjects([]); setAdhocInvoices([]); });
  }, []);

  const clients = useMemo(() => {
    const names = [...new Set(projects.map(p => p.clientName).filter(Boolean))].sort();
    return names.map(n => ({ value: n, label: n }));
  }, [projects]);

  return (
    <div data-testid="monthly-consumption-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-manrope font-bold text-3xl sm:text-4xl tracking-tight text-white" data-testid="consumption-title">
            Monthly Consumption
          </h1>
          <p className="text-zinc-500 text-sm mt-1 font-manrope">Financial year overview & monthly insights</p>
        </div>
        <div className="flex items-center gap-2">
          <Filter className="w-4 h-4 text-zinc-500" />
          <MultiSelectFilter
            label="Clients"
            options={clients}
            selected={selectedClients}
            onSelectionChange={setSelectedClients}
            testId="consumption-client-filter"
          />
        </div>
      </div>
      <MonthlyConsumptionSlide projects={projects} adhocInvoices={adhocInvoices} selectedClients={selectedClients} />
    </div>
  );
}
